module.exports = __webpack_public_path__ + "static/media/logo-black.a86486b4.svg";